module.exports = __webpack_public_path__ + "img/bg.c59fa257.png";